/* unplugin-vue-components disabled */import script from "./MobileTabBar.vue?vue&type=script&setup=true&lang=js"
export * from "./MobileTabBar.vue?vue&type=script&setup=true&lang=js"

import "./MobileTabBar.vue?vue&type=style&index=0&id=a5e6c078&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a5e6c078"]])

export default __exports__